// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lx-billing-card-icons[data-v-717648de]{display:flex !important;align-items:center !important;flex-direction:column !important}@media(max-width: 991.98px){.lx-billing-card-icons[data-v-717648de]{margin-top:1.25rem}}.lx-billing-card-icons__cards img[data-v-717648de]{margin-top:.3rem;width:60px}.lx-billing-card-icons__separator[data-v-717648de]{margin:1.5rem 0;width:75%}.lx-billing-card-icons__seal img[data-v-717648de]{margin-top:0 !important;width:160px}", ""]);
// Exports
module.exports = exports;
